import { useState, useEffect, useContext } from "react";
import { Container, Divider, Grid } from "@mui/material";
import { connect } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import axios from "axios";
import BASE_URL from "../../../../constants/baseUrls";
import weatherIconMap from "../../../../constants/weatherIconsMap";
import { formatPersianDate } from "../../../../utils/date";
import moment from "moment";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

//import general components
import { BaseButton } from "../../../common/base-button/base-button";

//import view components
import ItineraryItem from "../itinerary-item/itinerary-item";
import FreeItem from "../free-item/free-item";
import Description from "../description/description";
import Replace from "../replace/replace";

//import images and icons
import { ArrowDown2, ArrowUp2, Location } from "iconsax-react";

//import styles
import "react-multi-carousel/lib/styles.css";
import "./itinerary-list.scss";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { toast } from "react-toastify";

// Fix for default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Location Map Component
const LocationMap = ({ locations, onClose }) => {
    const validLocations = locations.filter(item => item.location && item.location.includes(","));

    const center = validLocations.reduce(
        (acc, item) => {
            const [lat, lng] = item.location.split(",").map(Number);
            return { lat: acc.lat + lat / validLocations.length, lng: acc.lng + lng / validLocations.length };
        },
        { lat: 0, lng: 0 },
    );

    const customIcon = new L.Icon({
        iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
        shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
    });

    return (
        <div className="map-modal-overlay">
            <div className="map-modal-content">
                <button className="map-modal-close" onClick={onClose}>
                    ✕
                </button>
                <div
                    style={{
                        position: "absolute",
                        top: "10px",
                        left: "10px",
                        zIndex: 1000,
                        background: "white",
                        padding: "5px",
                        borderRadius: "4px",
                    }}
                >
                    تعداد کل نقاط: {validLocations.length}
                </div>
                <MapContainer center={[center.lat, center.lng]} zoom={13} style={{ height: "100%", width: "100%" }}>
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                    {validLocations.map((item, index) => {
                        const [lat, lng] = item.location.split(",").map(Number);
                        const adjustedLat = lat + index * 0.0001;
                        const adjustedLng = lng + index * 0.0001;

                        return (
                            <Marker key={`${item.ID}-${index}`} position={[adjustedLat, adjustedLng]} icon={customIcon}>
                                <Popup>
                                    <div dir="rtl">
                                        <div
                                            style={{
                                                fontSize: "1.125rem",
                                                fontWeight: "bold",
                                                marginBottom: "4px",
                                            }}
                                        >
                                            {item.name1}
                                        </div>
                                        <div
                                            style={{
                                                fontSize: "1rem",
                                                color: "#6b7280",
                                                marginBottom: "6px",
                                            }}
                                        >
                                            {item.name2}
                                        </div>
                                        <div
                                            style={{
                                                fontSize: "0.875rem",
                                                color: "#6b7280",
                                                marginBottom: "8px",
                                            }}
                                        >
                                            {item.category}
                                        </div>
                                        <div
                                            style={{
                                                fontSize: "0.75rem",
                                                color: "#9ca3af",
                                            }}
                                        >
                                            نقطه #{index + 1}
                                        </div>
                                    </div>
                                </Popup>
                                {/* Add label beside each marker */}
                                <div
                                    style={{
                                        position: "absolute",
                                        backgroundColor: "#ffffff",
                                        padding: "4px 8px",
                                        borderRadius: "4px",
                                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                        transform: "translate(-50%, -100%)",
                                        whiteSpace: "nowrap",
                                        pointerEvents: "none",
                                        fontSize: "0.75rem",
                                        fontWeight: "bold",
                                        color: "#111827",
                                        direction: "rtl",
                                    }}
                                >
                                    #{index + 1}
                                </div>
                            </Marker>
                        );
                    })}
                </MapContainer>
            </div>
        </div>
    );
};

// Itinerary Row Component
const ItineraryDayRow = ({ row, index, dayListMap, locale, allDates, weather, weatherIconMap, handleDescriptionModal, handleReplaceModal, t }) => {
    const [showMap, setShowMap] = useState(false);

    return (
        <Grid className="itinerary-list__one-day" key={Math.random()} container item xs={12}>
            <Grid className="itinerary-list__itinerary-title" container item xs={1} rowGap={2} justifyContent="center" alignItems="center">
                <Grid container item xs={12} justifyContent="center" alignItems="center">
                    <span className="itinerary-list__day">{dayListMap[index.toString()]}</span>
                </Grid>
                <Grid container item xs={12} justifyContent="center" alignItems="center">
                    <span className="itinerary-list__date">
                        {locale === "fa"
                            ? formatPersianDate(allDates[index], {
                                  day: "numeric",
                                  month: "long",
                                  year: undefined,
                                  weekday: "long",
                              })
                            : moment(allDates[index]).format("ddd D MMM")}
                    </span>
                </Grid>
                {weather && (
                    <Grid container item xs={12} justifyContent={{ xs: "space-between", md: "center" }} alignItems="center">
                        <Grid container item xs={12} justifyContent="space-evenly">
                            <ArrowUp2 color="var(--red-color)" variant="Bold" />
                            <span className="itinerary-list__weather-max">{Math.round(weather.temperature_2m_max?.[index])}°</span>
                        </Grid>

                        <Grid container item xs={12} justifyContent="space-evenly">
                            <ArrowDown2 color="var(--blue-color)" variant="Bold" />
                            <span className="itinerary-list__weather-min">{Math.round(weather.temperature_2m_min?.[index])}°</span>
                        </Grid>
                    </Grid>
                )}
                <Grid container item xs={12} justifyContent="center" alignItems="center">
                    <Icon width="40" height="40" icon={weatherIconMap[weather?.weathercode?.[index]?.toString()]} />
                </Grid>

                {/* Add Map Button */}
                {row && row.length > 0 && (
                    <Grid container item xs={12} justifyContent="center" alignItems="center" paddingX={1}>
                        <BaseButton
                            text={t("showMap")}
                            color="secondary"
                            size="large"
                            radius="radius-10"
                            handleClick={() => setShowMap(true)}
                            rightIcon={<Location />}
                        />
                    </Grid>
                )}
            </Grid>

            <Grid className="itinerary-list__locations" container item xs={11} columnGap={2}>
                <Swiper
                    spaceBetween={0}
                    modules={[Pagination, Navigation]}
                    className="mySwiper"
                    navigation={true}
                    breakpoints={{
                        900: {
                            slidesPerView: 4.5,
                        },
                        1200: {
                            slidesPerView: 5.5,
                        },
                        1536: {
                            slidesPerView: 6.5,
                        },
                    }}
                >
                    {row?.length
                        ? row.map((item, index) => {
                              return (
                                  <SwiperSlide>
                                      {item.category === "free" && item.ID === 0 ? (
                                          <FreeItem info={item} handleReplaceModal={handleReplaceModal} index={index} length={row.length} />
                                      ) : (
                                          <ItineraryItem
                                              info={item}
                                              handleDescriptionModal={handleDescriptionModal}
                                              handleReplaceModal={handleReplaceModal}
                                              index={index}
                                              length={row.length}
                                          />
                                      )}
                                  </SwiperSlide>
                              );
                          })
                        : t("itineraryMessage3")}
                </Swiper>
                <Grid container justifyContent="center">
                    {row?.length ? "" : t("itineraryMessage3")}
                </Grid>
            </Grid>

            {/* Map Modal */}
            {showMap && <LocationMap locations={row} onClose={() => setShowMap(false)} />}
        </Grid>
    );
};

function ItineraryList({ data, destinationCoordinates, allDates, handleConfirmItinrary }) {
    //general
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const accessToken = localStorage.getItem("accessToken");
    const queryParams = new URLSearchParams(location.search);
    const selectedFlight = JSON.parse(sessionStorage.getItem("selectedFlight"));
    const selectedIntFlight = JSON.parse(sessionStorage.getItem("selectedIntFlight"));
    const selectedRooms = JSON.parse(sessionStorage.getItem("selectedRooms"));
    const selectedIntRooms = JSON.parse(sessionStorage.getItem("selectedIntRooms"));

    const dayListMap = {
        0: `${t("one")}`,
        1: `${t("two")}`,
        2: `${t("three")}`,
        3: `${t("four")}`,
        4: `${t("five")}`,
        5: `${t("six")}`,
        6: `${t("seven")}`,
        7: `${t("eight")}`,
        8: `${t("nine")}`,
        9: `${t("ten")}`,
    };

    useEffect(() => {
        searchParams.delete("action");
        setSearchParams(searchParams);
    }, []);

    //sessionStorage variables
    const itineraryInformation = JSON.parse(sessionStorage.getItem("itineraryInformation"));

    const cityId = itineraryInformation?.destination?.id ?? searchParams.get("cityId");

    //set itinerary energy to state
    const [itineraryList, setItineraryList] = useState([]);
    useEffect(() => {
        if (data?.length) {
            // data.map(item => item.map((itinerary, itineraryIndex) => {
            //     if (itineraryIndex === item.length - 1) {
            //         if (itinerary.remaining_energy < 50) {
            //             item.push({ ...itinerary, energy: false })
            //         }
            //     }
            // }))
            setItineraryList(data);
        }
    }, [data]);

    //weather
    const [weather, setWeather] = useState(null);
    const api = {
        base: "https://api.open-meteo.com/v1/forecast/",
    };
    const query = `latitude=${destinationCoordinates?.split(",")[0]}&longitude=${destinationCoordinates?.split(",")[1]}`;

    const getWeatherDaily = async () => {
        const response = await axios.get(
            `${api.base}?${query}&daily=weathercode,temperature_2m_max,temperature_2m_min&timezone=Asia%2FTehran&start_date=${itineraryInformation?.departureDate}&end_date=${itineraryInformation?.returnDate}`,
        );
        setWeather(response.data.daily);
    };

    const getWeatherHourly = async day => {
        setLoadingReplaceList(true);
        try {
            const response = await axios.get(
                `${api.base}?${query}&hourly=temperature_2m,weathercode&timezone=Asia/Tehran&start_date=${allDates[day - 1]}&end_date=${
                    allDates[day - 1]
                }`,
            );
            const temperatureList = response.data.hourly.temperature_2m.map(temp => {
                return temp ? temp : 12;
            });
            return temperatureList;
        } catch (error) {
            return [];
        }
    };

    useEffect(() => {
        if (destinationCoordinates) {
            getWeatherDaily();
        }
    }, [destinationCoordinates]);

    //handle description modal
    const [openDescription, setOpenDescription] = useState(false);
    const [description, setDescription] = useState();
    const [locationtInformation, setlocationtInformation] = useState();
    const [previousLocation, setPreviousLocation] = useState();
    const handleDescriptionModal = async (planInformation, index) => {
        queryParams.set("action", "description");
        const newSearch = `?${queryParams.toString()}`;
        setSearchParams(newSearch);

        setDescription(planInformation);
        setPreviousLocation(itineraryList[planInformation.day_number - 1][index - 1]);

        const response = await axios.get(`${BASE_URL}/location/info/`, {
            params: {
                pk: planInformation.ID,
            },
        });
        setlocationtInformation(response.data);
    };

    //handle replace modal
    const [openReplace, setOpenReplace] = useState(false);
    const [locationName, setLocationName] = useState("");
    const [locationImage, setLocationImage] = useState("");
    const handleReplaceModal = async planInformation => {
        queryParams.set("action", "replace");
        const newSearch = `?${queryParams.toString()}`;
        setSearchParams(newSearch);

        if (locale === "en") {
            setLocationName(planInformation.name1);
        } else {
            setLocationName(planInformation.name2);
        }
        setLocationImage(planInformation.image);
        // const temperaturesDay = await getWeatherHourly(planInformation.day_number);
        getReplaceList(planInformation.plan_id, planInformation.global_id);
    };

    //handle modal change
    useEffect(() => {
        if (searchParams.get("action") === "description") setOpenDescription(true);
        else setOpenDescription(false);

        if (searchParams.get("action") === "replace") setOpenReplace(true);
        else setOpenReplace(false);
    }, [searchParams]);

    //replace list request
    const [replaceList, setReplaceList] = useState([]);
    const [loadingReplaceList, setLoadingReplaceList] = useState(false);
    const getReplaceList = async (planId, globalId) => {
        try {
            setLoadingReplaceList(true);
            const params = JSON.stringify({
                // temperatures: temperaturesDay,
                edit_data: {
                    plan_id: planId,
                    removed_loc_global_id: globalId,
                },
            });
            const response = await axios.post(`${BASE_URL}/itinerary/plan_edit/${cityId}/`, params, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            setReplaceList(response.data);
        } catch (error) {
            toast.error(t("errorMessage"));
            searchParams.delete("action");
            setSearchParams(searchParams);
        } finally {
            setLoadingReplaceList(false);
        }
    };

    //rating modal
    const handleRating = () => {
        if (!!accessToken) {
            setSearchParams({ action: "rating" });
        } else {
            setSearchParams({ action: "login" });
        }
    };

    return (
        <Container maxWidth="xl">
            <Grid className="itinerary-list" container item xs={12} rowGap={3} columnGap={3} justifyContent="center" my={2}>
                <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                    <Grid className="itinerary-list__title" component="span" container item xs="auto">
                        {t("itinerary")}
                    </Grid>
                    <Divider sx={{ width: { xs: "80%", md: "89%", xl: "90%" } }} />
                </Grid>
                {itineraryList?.length
                    ? itineraryList?.map((row, index) => {
                          return (
                              <ItineraryDayRow
                                  row={row}
                                  index={index}
                                  dayListMap={dayListMap}
                                  locale={locale}
                                  allDates={allDates}
                                  weather={weather}
                                  weatherIconMap={weatherIconMap}
                                  handleDescriptionModal={handleDescriptionModal}
                                  handleReplaceModal={handleReplaceModal}
                                  t={t}
                              />
                          );
                      })
                    : ""}

                <Description
                    open={openDescription}
                    setOpen={setOpenDescription}
                    description={description}
                    locationtInformation={locationtInformation}
                    previousLocation={previousLocation}
                />

                <Replace
                    open={openReplace}
                    setOpen={setOpenReplace}
                    list={replaceList}
                    loadingReplaceList={loadingReplaceList}
                    locationName={locationName}
                    locationImage={locationImage}
                />

                {location.pathname === `/${locale}/itinerary/itinerary-page` && (
                    <>
                        {!!selectedFlight  || !!selectedIntFlight || !!selectedRooms || !!selectedIntRooms ? (
                            <Grid item xs={5} md={1.5}>
                                <BaseButton
                                    text={t("nextLevel")}
                                    color="primary"
                                    size="large"
                                    radius="radius-10"
                                    handleClick={handleConfirmItinrary}
                                />
                            </Grid>
                        ) : null}
                        <Grid item xs={5} md={1.5}>
                            <BaseButton text={t("rating")} color="secondary" size="large" radius="radius-10" handleClick={handleRating} />
                        </Grid>
                    </>
                )}
            </Grid>
        </Container>
    );
}

function mapStateToProps(state) {
    return {
        data: state.itineraryList,
    };
}

export default connect(mapStateToProps)(ItineraryList);

// const LocationMap = ({ locations, onClose }) => {
//     const validLocations = locations.filter(item => item.location && item.location.includes(","));

//     const center = validLocations.reduce(
//         (acc, item) => {
//             const [lat, lng] = item.location.split(",").map(Number);
//             return { lat: acc.lat + lat / validLocations.length, lng: acc.lng + lng / validLocations.length };
//         },
//         { lat: 0, lng: 0 },
//     );

//     // Create custom icon
//     const customIcon = new L.Icon({
//         iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
//         shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
//         iconSize: [25, 41],
//         iconAnchor: [12, 41],
//         popupAnchor: [1, -34],
//         shadowSize: [41, 41],
//     });

//     return (
//         <div className="map-modal-overlay">
//             <div className="map-modal-content">
//                 <button className="map-modal-close" onClick={onClose}>
//                     ✕
//                 </button>
//                 <div
//                     style={{
//                         position: "absolute",
//                         top: "10px",
//                         left: "10px",
//                         zIndex: 1000,
//                         background: "white",
//                         padding: "5px",
//                         borderRadius: "4px",
//                     }}
//                 >
//                     Total Points: {validLocations.length}
//                 </div>
//                 <MapContainer center={[center.lat, center.lng]} zoom={13} style={{ height: "100%", width: "100%" }}>
//                     <TileLayer
//                         url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//                         attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//                     />
//                     {validLocations.map((item, index) => {
//                         const [lat, lng] = item.location.split(",").map(Number);
//                         // Add a small offset to each marker to prevent exact overlapping
//                         const adjustedLat = lat + index * 0.0001;
//                         const adjustedLng = lng + index * 0.0001;

//                         return (
//                             <Marker key={`${item.ID}-${index}`} position={[adjustedLat, adjustedLng]} icon={customIcon}>
//                                 <Popup>
//                                     <div>
//                                         <strong>{item.name1}</strong>
//                                         <br />
//                                         {item.name2}
//                                         <br />
//                                         {item.category}
//                                         <br />
//                                         <small>Point #{index + 1}</small>
//                                     </div>
//                                 </Popup>
//                             </Marker>
//                         );
//                     })}
//                 </MapContainer>
//             </div>
//         </div>
//     );
// };
// const LocationMap = ({ locations, onClose }) => {
//     const center = locations.reduce(
//         (acc, item) => {
//             const [lat, lng] = item.location.split(",").map(Number);
//             return { lat: acc.lat + lat / locations.length, lng: acc.lng + lng / locations.length };
//         },
//         { lat: 0, lng: 0 },
//     );

//     return (
//         <div className="map-modal-overlay">
//             <div className="map-modal-content">
//                 <button className="map-modal-close" onClick={onClose}>
//                     ✕
//                 </button>
//                 <MapContainer center={[center.lat, center.lng]} zoom={13} style={{ height: "100%", width: "100%" }}>
//                     <TileLayer
//                         url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//                         attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//                     />
//                     {locations.map(item => {
//                         const [lat, lng] = item.location.split(",").map(Number);
//                         return (
//                             <Marker key={item.ID} position={[lat, lng]}>
//                                 <Popup>
//                                     <strong>{item.name1}</strong>
//                                     <br />
//                                     {item.name2}
//                                     <br />
//                                     {item.category}
//                                 </Popup>
//                             </Marker>
//                         );
//                     })}
//                 </MapContainer>
//             </div>
//         </div>
//     );
// };
